import { Order, OrderDealStatus } from '../../../types';

export type StatusColumn = {
  id: OrderDealStatus;
  label: string;
  isActive: boolean;
};

export const PIPELINE_COLUMNS: StatusColumn[] = [
  { id: 'on_hold', label: 'On Hold', isActive: false },
  { id: 'new', label: 'New Lead', isActive: true },
  { id: 'scheduled', label: 'Onsite Scheduled', isActive: true },
  { id: 'quote_requested', label: 'Quote Needed', isActive: true },
  { id: 'quote_sent', label: 'Quote Sent', isActive: true },
  { id: 'quote_reviewed', label: 'Quote Reviewed', isActive: true },
  { id: 'won', label: 'Won', isActive: false },
  { id: 'lost', label: 'Lost', isActive: false },
];

// Derived from PIPELINE_COLUMNS to avoid duplication
export const ACTIVE_STATUSES: OrderDealStatus[] = PIPELINE_COLUMNS.filter((col) => col.isActive).map((col) => col.id);

export const getOrdersByStatus = (orders: Order[], status: OrderDealStatus): Order[] => {
  return orders.filter((order) => order.deal_status_code === status);
};

export const getTotalValueByStatus = (orders: Order[], status: OrderDealStatus): number => {
  return getOrdersByStatus(orders, status).reduce((sum, order) => sum + (order.total_quote_value || 0), 0);
};
